import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { fromShipperDocumentsPageParamsSchema } from 'src/pages/shippers/details/documents/from-shipper/schema';

export function usePageParams() {
  return usePageParamsFromSchema(fromShipperDocumentsPageParamsSchema);
}

type PageParams = ReturnType<typeof usePageParams>;
